import { useI18n, useL } from "../i18n";
import { Sparkles, ArrowUpRight } from "lucide-react";

export default function MonetizationAd({ variant = "banner" }) {
  const { t } = useI18n();
  const L = useL();

  if (variant === "native") {
    return (
      <div
        data-testid="ad-native"
        className="relative rounded-3xl overflow-hidden border border-[#E6DED3] bg-gradient-to-br from-[#F3EDE4] to-[#FAF7F2] p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-5"
      >
        <div className="absolute top-3 end-3 text-[10px] uppercase tracking-widest bg-[#1C1917] text-[#FAF7F2] px-2 py-0.5 rounded-full">
          {t("sponsored")}
        </div>
        <div className="h-16 w-16 shrink-0 rounded-2xl bg-[#1C1917] text-[#FAF7F2] grid place-items-center">
          <Sparkles className="h-7 w-7" />
        </div>
        <div className="flex-1">
          <div className="text-[11px] uppercase tracking-widest text-[#C85A32] font-semibold">
            {L({ ar: "شركاء رحّال", en: "Rahhal partners", fr: "Partenaires Rahhal" })}
          </div>
          <h3 className="mt-1 font-display text-xl sm:text-2xl text-[#1C1917]">
            {L({
              ar: "احجز فندقك بسعر أقل ٢٥٪ حصرياً لمستخدمي رحّال",
              en: "Book your hotel 25% cheaper — exclusive Rahhal deal",
              fr: "Réservez votre hôtel 25 % moins cher — offre exclusive Rahhal"
            })}
          </h3>
          <p className="mt-1 text-sm text-[#57534E]">
            {L({
              ar: "عروض مختارة يدوياً على أفضل فنادق المنطقة، صالحة لهذا الشهر.",
              en: "Curated deals on top regional hotels, valid this month.",
              fr: "Offres sélectionnées sur les meilleurs hôtels de la région, valables ce mois-ci."
            })}
          </p>
        </div>
        <a
          href="#"
          className="shrink-0 inline-flex items-center gap-2 px-5 h-11 rounded-full bg-[#C85A32] hover:bg-[#B24C28] text-[#FAF7F2] font-medium transition-colors"
        >
          {L({ ar: "اعرض العرض", en: "View deal", fr: "Voir l'offre" })}
          <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
    );
  }

  // Banner variant
  return (
    <div
      data-testid="ad-banner"
      className="relative w-full rounded-2xl border border-[#E6DED3] bg-white/60 backdrop-blur px-4 py-3 flex items-center justify-between gap-4"
    >
      <div className="text-[10px] uppercase tracking-widest text-[#78716C]">{t("sponsored")}</div>
      <div className="text-sm text-[#1C1917] flex-1 truncate">
        {L({
          ar: "✈️ أطلق العنان لعروض السفر — طيران من ٩٩$ للمنطقة",
          en: "✈️ Unlock travel deals — flights from $99 across the region",
          fr: "✈️ Débloquez des offres de voyage — vols dès 99 $ dans la région"
        })}
      </div>
      <a href="#" className="text-sm font-medium text-[#C85A32] shrink-0">
        {L({ ar: "اكتشف", en: "Discover", fr: "Découvrir" })}
      </a>
    </div>
  );
}
